<template>
    <div class="bottom">
        <div class="bot" :style="bot">
            {{ help }}
            <span style="margin-left: 10%">{{ consult }}</span>
        </div>
        <div class="bot_content">
            <a
                href="https://bszs.conac.cn/sitename?method=show&id=078BAC9C810676AFE053012819ACD724"
            >
                <div
                    class="back"
                    style="background-color: inherit"
                    :style="{ backgroundImage: 'url(' + sydw + ')' }"
                ></div>
            </a>

            <div class="bot_text">
                <p :style="font">{{ copyright }}</p>
                <p :style="font">
                    <a class="beian" href="https://beian.miit.gov.cn/">{{ icp }}</a>
                </p>
                <p :style="font">{{ put }}</p>
                <p :style="font">{{ site }}</p>
                <p :style="font">{{ postal }}</p>
            </div>
            <div class="rw">
                <div class="back" :style="{ backgroundImage: 'url(' + gzh + ')' }"></div>
                <p>公众号</p>
            </div>
            <div class="rw">
                <!-- <div class="back" :style="{ backgroundImage: 'url(' + weibo + ')' }"></div>
                <p>微博</p> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            screenWidth: '',
            font: '',
            bot: '',

            help: '',
            consult: '',
            copyright: '',
            icp: '',
            put: '',
            site: '',
            postal: '',
            weibo: '',
            gzh: '',
            sydw: '',
        };
    },
    created() {
        this.$http.get('footer/selectAll').then(res => {
            let list = res.footer;
            const mymap = new Map();
            for (let obj of list) {
                mymap.set(obj.paramName, obj);
            }
            // console.log(list);
            this.help = mymap.get('急救电话').paramName + ':' + mymap.get('急救电话').paramValue;
            this.consult =
                mymap.get('24小时咨询电话').paramName +
                ':' +
                mymap.get('24小时咨询电话').paramValue;
            this.copyright =
                mymap.get('版权所有').paramName + ':' + mymap.get('版权所有').paramValue;
            this.icp = mymap.get('ICP备案号').paramName + ':' + mymap.get('ICP备案号').paramValue;

            this.put =
                mymap.get('省公网安备：贵公网安备').paramName +
                ':' +
                mymap.get('省公网安备：贵公网安备').paramValue;

            this.site = mymap.get('地址').paramName + ':' + mymap.get('地址').paramValue;
            this.postal = mymap.get('邮政编码').paramName + ':' + mymap.get('邮政编码').paramValue;

            this.weibo = mymap.get('微博').paramValue;
            // console.log('gzg', this.weibo);
            this.gzh = mymap.get('公众号').paramValue;
            this.sydw = mymap.get('事业单位').paramValue;
        });
    },
    mounted() {
        this.screenWidth = document.body.clientWidth;
        if (document.body.clientWidth < 1200) {
            this.font = 'font-size: 14px;';
            this.bot = 'font-size: 30px;';
        }
    },
    methods: {
        openLink() {
            window.open(
                'https://bszs.conac.cn/sitename?method=show&id=078BAC9C810676AFE053012819ACD724'
            );
        },
    },
};
</script>
<style lang="less">
.bottom {
    img {
        width: 100%;
        height: 100%;
    }
    // position: fixed;
    width: 100%;
    background: #125e57;
    margin-top: 113px;

    .bot {
        height: 110px;
        line-height: 110px;
        border-bottom: solid 1px #f3f3f3;
        font-size: 35px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #f3f3f3;
        padding-left: 10%;
    }

    .bot_content {
        width: 100%;
        height: 372px;
        background: #125e57;
        display: flex;
        justify-content: space-between;
        align-items: center;
        float: left;
        padding: 0 5%;

        .sydw {
            width: 15%;
            height: 241px;
        }

        .bot_text {
            width: 25%;
            margin-left: -11%;
        }

        p {
            // white-space: nowrap;
            font-family: SourceHanSansSC-Regular;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 33px;
            letter-spacing: 1px;
            color: #f3f3f3;
        }

        .rw {
            width: 180px;
            height: 180px;

            p {
                text-align: center;
                font-family: SourceHanSansSC-Regular;
                font-size: 20px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #f3f3f3;
                line-height: 150%;
            }
        }
    }

    .beian {
        color: #fff;
    }
    .back {
        height: 180px;
        width: 180px;
        background-size: cover;
        background-repeat: repeat;
        background-position: center;
        background-color: #fff;
    }
}
</style>
